import type { ButtonLinkProps } from '@change-corgi/design-system-legacy/components/actions';
import { ButtonLink as LegacyButtonLink } from '@change-corgi/design-system-legacy/components/actions';

import { useIsSunriseEnabled } from '../../../../../hooks/isSunriseEnabled';

export const ButtonLink = ({ children, ...props }: ButtonLinkProps) => {
	const {
		data: { isSunriseEnabled },
	} = useIsSunriseEnabled();

	return (
		<LegacyButtonLink {...props} {...(isSunriseEnabled && { size: 'large' })}>
			{children}
		</LegacyButtonLink>
	);
};
